export const OrderItemSubtotalAddonsFragment = /* GraphQL */ `
	fragment OrderItemSubtotalAddonsFragment on OrderItemSubtotalAddOns {
		offer {
			metadata
			amount
			is_custom_value
		}
		discount {
			is_divided
			type
			value
			amount
		}
		vat {
			is_included
			percentage
			amount
		}
		service_charge {
			is_included
			percentage
			amount
		}
		service_charge_bd {
			is_included
			percentage
			amount
		}
		adjustment {
			amount
		}
		tax {
			percentage
			amount
		}
		card_surcharge {
			percentage
			amount
		}
	}
`;

export const OrderItemOptionSubtotalAddonsFragment = /* GraphQL */ `
	fragment OrderItemOptionSubtotalAddonsFragment on OrderItemSubtotalAddOns {
		offer {
			metadata
			amount
			is_custom_value
		}
		discount {
			is_divided
			type
			value
			amount
		}
		vat {
			is_included
			percentage
			amount
		}
		service_charge {
			is_included
			percentage
			amount
		}
		service_charge_bd {
			is_included
			percentage
			amount
		}
		adjustment {
			amount
		}
		tax {
			percentage
			amount
		}
		card_surcharge {
			percentage
			amount
		}
	}
`;
